import { render, staticRenderFns } from "./fiduciary-alliance.vue?vue&type=template&id=4b6634a2"
import script from "./fiduciary-alliance.vue?vue&type=script&lang=js"
export * from "./fiduciary-alliance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports